var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('ul',[_c('li',{staticStyle:{"margin-bottom":"5px","margin-top":"0"}},[_vm._v("\n            JS Investments Digital Onboarding | Powered by Idenfo\n        ")])])])
}]

export { render, staticRenderFns }